<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年01月07日 18:49:33 +0800
 * @最后修改时间: 2022-02-18 11:38:19
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Site\siteType\editSiteType.vue
 -->
<template>
  <ContentLayout
    :title="
      iSEdited
        ? $t('label_essweb_siteType_form_editTitle')
        : $t('label_essweb_siteType_form_viewTitle')
    "
    widthClass="max-1000"
    delBtn
    backgroundClass="white"
    :initData="siteTypeData"
    @change="(changed) => (isChanged = changed)"
    :checkData="[
      'site_type_abbr',
      'site_type_code',
      'site_type_description',
      'site_type_name',
      'remarks',
    ]"
    :editBtn="!iSEdited"
    @edit="iSEdited = true"
    @delete="
      $confirmDo($t('label_essweb_siteType_list_title')).then((res) => {
        res ? toDelete() : null;
      })
    "
  >
    <!-- content -->
    <template v-slot:page-main>
      <v-form ref="form" lazy-validation>
        <v-row>
          <v-col xs="12" sm="6" md="4" lg="4" cols="12">
            <inputTextFiledMultiLang
              maxlength="100"
              :filled="iSEdited"
              :readonly="!iSEdited"
              :bindData="siteTypeData.site_type_name"
              @change="
                (valueArr) => {
                  siteTypeData.site_type_name = valueArr;
                }
              "
              :label="$t('label_essweb_siteType_form_siteTypeNameLabel')"
              :rules="$GetRules(['_Require_Rules'], [null])"
            />
          </v-col>
          <v-col xs="12" sm="6" md="4" lg="4" cols="12">
            <inputTextFiledMultiLang
              maxlength="20"
              :filled="iSEdited"
              :readonly="!iSEdited"
              :bindData="siteTypeData.site_type_abbr"
              @change="
                (valueArr) => {
                  siteTypeData.site_type_abbr = valueArr;
                }
              "
              :label="$t('label_essweb_siteType_form_siteTypeAbbrLabel')"
              :rules="$GetRules(['_Require_Rules'], [null])"
            />
          </v-col>
          <v-col xs="12" sm="6" md="4" lg="4" cols="12">
            <normalInputTextFiled
              v-model="siteTypeData.site_type_code"
              maxlength="20"
              :filled="iSEdited"
              :readonly="!iSEdited"
              :rules="$GetRules(['_Require_Rules'], [null])"
              :label="$t('label_essweb_ClaimReason_form_codeLabel')"
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <inputTextFiledMultiLang
              maxlength="500"
              :filled="iSEdited"
              :readonly="!iSEdited"
              :bindData="siteTypeData.site_type_description"
              @change="
                (valueArr) => {
                  siteTypeData.site_type_description = valueArr;
                }
              "
              :label="$t('label_essweb_siteType_form_descriptionLabel')"
            />
          </v-col>
          <v-col xs="12" sm="12" md="12" lg="12" cols="12">
            <v-sheet class="text--secondary">{{
              $t("label_essweb_siteType_form_remarkLabel")
            }}</v-sheet>
            <v-textarea
              rows="5"
              no-resize
              maxlength="500"
              dense
              :filled="iSEdited"
              single-line
              v-model="siteTypeData.remarks"
              :readonly="!iSEdited"
              counter="500"
            ></v-textarea>
          </v-col>
        </v-row>
      </v-form>
    </template>
    <!-- actions -->
    <template v-slot:page-actions>
      <CardActions
        saveBtn
        @save="toSave"
        @cancel="$toBack(isChanged)"
        v-if="iSEdited"
      />
    </template>
    <!-- actions -->
    <template v-slot:tools-main> </template>
  </ContentLayout>
</template>
<script>
import { mapGetters } from "vuex";
export default {
  name: "newSiteType",
  computed: {
    ...mapGetters(["companyLang"]),
  },
  mounted() {
    this.getSiteTypeDetailsByUuid();
  },
  data() {
    return {
      isChanged: false,
      siteTypeData: {
        site_type_name: "",
        site_type_code: "",
        site_type_abbr: "",
        site_type_description: "",
        remarks: "",
      },
      iSEdited: true,
    };
  },
  methods: {
    toBack: function () {
      // if (this.iSEdited) {
      //   this.iSEdited = false;
      // } else {
      this.$router.back();
      // }
    },
    toDelete() {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_site_type",
        url: "/site-type/delete-site-type-table/",
        data: {
          uuids: this.$route.params.id,
        },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_siteType_list_deleteSiteTypeSuccessLabel"
          ),
          type: "success",
        });
        that.toBack();
      });
    },

    toSave: function () {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$Request({
        method: "POST",
        table: "ess_site_type",
        url: "/site-type/update-site-type-table/",
        data: {
          uuid: this.$route.params.id,
          site_type_name: this.$transCommonLangKey(
            this.siteTypeData.site_type_name,
            this.siteTypeData.site_type_name_save
          ),
          site_type_description: this.$transCommonLangKey(
            this.siteTypeData.site_type_description,
            this.siteTypeData.site_type_description_save
          ),
          site_type_abbr: this.$transCommonLangKey(
            this.siteTypeData.site_type_abbr,
            this.siteTypeData.site_type_abbr_save
          ),
          site_type_code: this.siteTypeData.site_type_code,
          remarks: this.siteTypeData.remarks,
        },
      }).then((res) => {
        // that.getSiteTypeDetailsByUuid();
        that.$showMessage({
          text: that.$t(
            "message_essweb_siteType_list_updateSiteTypeSuccessLabel"
          ),
          type: "success",
        });
        this.toBack(); //回到不能编辑状态
      });
    },
    getSiteTypeDetailsByUuid: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_site_type",
        url: "/site-type/get-site-type-details/",
        data: { uuid: this.$route.params.id },
      }).then((res) => {
        res.data["site_type_abbr_save"] = res.data.site_type_abbr;
        res.data.site_type_abbr = that.$transOnLineCommonLangKey(
          that.companyLang,
          res.data.site_type_abbr
        );
        res.data["site_type_name_save"] = res.data.site_type_name;

        res.data.site_type_name = that.$transOnLineCommonLangKey(
          that.companyLang,
          res.data.site_type_name
        );
        res.data["site_type_description_save"] = res.data.site_type_description;
        res.data.site_type_description = that.$transOnLineCommonLangKey(
          that.companyLang,
          res.data.site_type_description
        );
        that.siteTypeData = res.data;
      });
    },
  },
};
</script>
